<template>
    <ReportsWrapper :report="report" data-test-id="call-reports-number">
        <w-loader v-if="loading"/>
        <div v-else>
            <LogarithmicSwitcher
                v-model="logarithmic"
                class="ml-5"
            />
            <NumberChart
                :items="prepare_items({...report.items})"
                :numbers="report.numbers"
                :logarithmic="logarithmic"
                :formatters="report.formatters"
                :fields="report.fields"
                :key="`logarithmic-${logarithmic}-chart`"
            />

            <NumberTable
                :items="prepare_items({...report.items})"
                :numbers="report.numbers"
                :logarithmic="logarithmic"
                :formatters="report.formatters"
                :fields="report.fields"
                :key="`logarithmic-${logarithmic}-table`"
                data-test-id="botttom-table"
          />
        </div>
    </ReportsWrapper>
</template>

<script>
  import { vueComponent } from '../../../../libs/helpers2';
  import PerPhoneNumber from '../../../../models/PerPhoneNumber';
  import ReportsWrapper from '../elements/ReportWrapper.vue';
  import NumberTable from '../elements/tables/Numbers.vue';
  import NumberChart from '../elements/charts/PerNumber.vue';
  import LogarithmicSwitcher from '../../../elements/logarithmic-representation-switcher.vue';

  export default {
    components: {
        ReportsWrapper,
        NumberTable,
        NumberChart,
        LogarithmicSwitcher,
    },
    data() {
      return {
        loading: false,
        logarithmic: false,
        items: null,
        report: new PerPhoneNumber(this.$session, vueComponent(this)),
      };
    },
    async created() {
        await this.$data.report.loadItems();
    },
    methods: {
      prepare_items(items) {
        if (!items) return {};

        const transformed = {};
        for (const key of Object.keys(items)) {
          transformed[key] = items[key].map((item) => {
            const val = item.value || 0;
            let displayValue = item.value || 0;
            if (this.$data.logarithmic) {
              displayValue = val > 0 ? Math.log(val) / Math.log(2) : 0;
            }

            return {
              ...item,
              display_value: displayValue
            };
          });
        }
        return transformed;
      }
    },
  };
</script>
